import { SpherePlatformApp } from '@sphere/platform';
import { calendarManagerApp } from './calendar-manager';
import { PATHS } from './calendar-manager.paths';

export const CalendarManagerApp: SpherePlatformApp = {
    APP: calendarManagerApp,
    PATHS
};
